// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a9c092cdd1f65fa310ed","655":"c6c7b7925a270cab77e3"}[chunkId] + ".js";
};